/* eslint-disable no-param-reassign */
/* @ngInject */

export default ($rootScope, $scope, webpage, accountService, changesService, uiService) => {
  $scope.Model = {
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  accountService
    .readAccount({ id: $rootScope.CurrentAccount.id })
    .then((data) => {
      // Overwrite $rootScope values in case they've reverted to values within Token
      $rootScope.CurrentAccount.notifications = data.notifications;
    })
    .then(() => {
      // Declare Model as Ready and start rendering the page
      webpage.pageTitle('My updates and reminders : Settings');
      $scope.Model.isReady = true;
    });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.saveAccount = (data) => {
    if (data?.id && !_.isEmpty(data?.notifications)) {
      $rootScope.CurrentAccount.notifications = data.notifications;
      changesService.change();
    }
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const accountData = {
      id: $rootScope.CurrentAccount.id,
      notifications: $rootScope.CurrentAccount.notifications
    };
    return accountService.updateAccount(accountData).then((result) => {
      if (result.status) {
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);
};
